import { css } from '@emotion/react'
import { breakpoint, pxToRem } from '@twistopayments/design-system/styles'

export const heroDescription = css`
  font-size: ${pxToRem(17)};
  margin-top: 0;

  ${breakpoint.up('sm')} {
    font-size: ${pxToRem(24)};
  }
`

export const highlighted = css`
  font-weight: 600;
`
